import { archives } from "@/mocks/homeData";

export default function ArchiveGrid() {
  return (
    <section id="archives" className="scroll-mt-20 border-y border-background-200/70 bg-background-100/60">
      <div className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div className="max-w-2xl">
            <p className="text-xs font-medium uppercase tracking-widest text-accent-700">事件档案 · 图文复盘</p>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              把「来龙去脉」存成一份份看得懂的档案
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              每个事件从首曝、身份起底、背景深扒到关联人物与旧料翻出，一步步拆给你看，附当前进展状态。
            </p>
          </div>
          <div className="flex flex-wrap gap-2">
            {["全部档案", "持续发酵", "已复盘", "观察中"].map((f, i) => (
              <button
                key={f}
                type="button"
                className={`rounded-full px-4 py-1.5 text-sm font-medium transition-colors whitespace-nowrap ${
                  i === 0
                    ? "bg-foreground-950 text-background-50"
                    : "bg-background-50 text-foreground-700 ring-1 ring-secondary-200 hover:text-primary-700"
                }`}
              >
                {f}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {archives.map((a) => (
            <article
              key={a.id}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-colors hover:border-primary-200"
            >
              <div className="relative h-52 overflow-hidden md:h-56">
                <img
                  src={a.img}
                  alt={a.title}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-md bg-background-50/90 px-2.5 py-1 text-xs font-semibold text-primary-700 backdrop-blur">
                  <i className="ri-vip-crown-line text-accent-600" />
                  {a.id}
                </span>
                <span className="absolute bottom-3 right-3 inline-flex items-center gap-1 rounded-md bg-background-950/70 px-2.5 py-1 text-xs text-background-50 backdrop-blur">
                  <i className="ri-fire-line text-accent-300" />
                  {a.heat}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <div className="flex items-center gap-2 text-xs">
                  <span className="text-secondary-500">{a.meta}</span>
                  <span className="inline-flex items-center gap-1 rounded-full bg-accent-100 px-2 py-0.5 text-accent-900">
                    <i className="ri-time-line" />
                    {a.status}
                  </span>
                </div>
                <h3 className="mt-2 font-heading text-base font-bold leading-snug text-foreground-900 group-hover:text-primary-700">
                  {a.title}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{a.lead}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200/70 pt-3">
                  <span className="text-xs text-secondary-500">约 6–12 分钟读完</span>
                  <button
                    type="button"
                    className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 transition-colors hover:text-primary-700 whitespace-nowrap"
                  >
                    阅读档案
                    <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}